import firebase from "datastore/database";

export default function observeCollection(path, cbs) {
  const validFunction = (propName) =>
    cbs?.[propName] && typeof cbs[propName] === "function";

  return firebase
    .firestore()
    .collection(path)
    .onSnapshot((snapshot) => {
      const updates = {
        added: [],
        modified: [],
        removed: [],
      };

      if (snapshot.empty) {
        cbs.onAdded([]);
        return;
      }

      snapshot.docChanges().forEach((change) => {
        if (change.type === "added") {
          updates.added.push({ uid: change.doc.id, ...change.doc.data() });
        }
        if (change.type === "modified") {
          updates.modified.push({ uid: change.doc.id, ...change.doc.data() });
        }
        if (change.type === "removed") {
          updates.removed.push({ uid: change.doc.id, ...change.doc.data() });
        }
      });
      if (updates.added.length > 0 && validFunction("onAdded")) {
        cbs.onAdded(updates.added);
      }
      if (updates.modified.length > 0 && validFunction("onModified")) {
        cbs.onModified(updates.modified);
      }
      if (updates.removed.length > 0 && validFunction("onRemoved")) {
        cbs.onRemoved(updates.removed);
      }
    });
}
